<template>
  <div class="product-details-content-draggable-categories">
    <div class="d-flex mr-lg-8 pr-lg-0 mr-6 pr-3">
      <div
        class="d-flex justify-content-between flex-fill pt-2 pb-3 pr-lg-6 mr-9"
      >
        <strong class="fs-13">Nome</strong>
      </div>
      <div class="status-box">
        <strong class="fs-13 mr-2">Status</strong>
      </div>
    </div>
    <draggable
      :value="value"
      @input="val => $emit('input', val)"
      handle=".handle"
      group="categories"
    >
      <div class="flex-column" v-for="(category, index) in value" :key="index">
        <div class="d-flex align-items-center border-bottom pt-3 pb-5">
          <div class="d-flex align-items-center text-truncate flex-fill">
            <i
              class="fa fa-grip-vertical handle lead"
              style="color: #B8BACC;"
              v-if="handle"
            ></i>
            <div
              class="d-flex justify-content-between align-items-center flex-fill px-5"
            >
              <span class="fs-13">{{ category.name }}</span>
            </div>
            <div class="d-flex align-items-center text-truncate status-box">
              <span
                :class="{
                  'active-badge': category.is_active,
                  'inactive-badge': !category.is_active
                }"
                v-html="statusHtml(category)"
              >
              </span>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-end">
            <actions-dropdown
              :left="false"
              :right="true"
              :actions="getActions(category)"
              @edit="$emit('edit-category', category)"
              @change-status="$emit('change-status', category)"
              @delete="$emit('remove-category', category)"
            />
          </div>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "draggable-categories",
  components: { draggable },
  props: {
    value: Array,
    handle: Boolean
  },
  data() {
    return {
      collapsed: []
    };
  },
  methods: {
    statusHtml(item) {
      return item.is_active ? "Ativo" : "Inativo";
    },
    getActions(item) {
      return [
        {
          text: "Editar",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "edit"
        },
        {
          text: item.is_active ? "Desativar" : "Ativar",
          icon: "icon-power",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "change-status"
        },
        {
          text: "Excluir categoria",
          class: "text-danger",
          icon: "icon-trash",
          confirmation: {
            enable: true,
            text: "Tem certeza que deseja excluir esta categoria?",
            newDesign: true,
            submitText: "Excluir",
            submitButtonClass: "btn-danger"
          },
          event: "delete"
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.product-details-content-draggable-categories {
  .btn-collapse {
    background: none;
    border: none;
    padding: 8px;
    font-size: 24px;
    color: #666;

    i {
      transition: all 0.2s;
      display: inline-block;

      &.collapsed {
        transform: rotate(180deg);
      }
    }
  }

  .btn-link {
    padding: 0;
  }

  small {
    font-size: 10px;
    line-height: 12px;
    display: block;
    color: #888;
  }
}

::v-deep .actions-dropdown .dropdown-toggle i,
::v-deep .btn-outline-dark {
  border: none;
  color: rgba(119, 120, 142, 0.87);
}

.status-box {
  width: 80px;
}
</style>
